import { ViewFactory } from 'src/3rds/cube-react'

import { OverviewScope } from '../overview_scopes'

import { HeaderScope } from '../overview_scopes'
import HeaderView from './overview-header'
import OverviewView from './overview_view'

export function registerViews(rv = ViewFactory.register) {
    rv(OverviewScope, OverviewView)
    rv(HeaderScope, HeaderView)
}
